import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthRepository } from '../repositories/auth.repository';
import { UserModel } from '../models';

/**
 * Use case para obter dados do usuário atual
 * Baseado no obter_usuario_usecase.dart do Flutter
 */
@Injectable({
  providedIn: 'root'
})
export class ObterUsuarioUseCase {
  constructor(private authRepository: AuthRepository) {}

  /**
   * Obtém os dados do usuário autenticado
   * @returns Observable<UserModel | null> - Dados do usuário ou null se não autenticado
   */
  execute(): Observable<UserModel | null> {
    return this.authRepository.getCurrentUser();
  }
}
